import clsx from "clsx";
import { twMerge } from "tailwind-merge";

import { useWizardContext } from "./hooks";

interface Props {
  className?: string;
}

export const WizardNavigation = ({ className }: Props) => {
  const { prevStep, nextStep, disabled, onChange } = useWizardContext();

  return (
    <div
      className={twMerge(
        "h-[60px] px-8 py-3.5 flex items-center justify-between border-t border-v2-tertiary",
        "text-xs bg-v2-overlay-shadow-200 backdrop-blur-sm",
        className,
      )}
    >
      <div>
        {prevStep && (
          <Button
            disabled={disabled}
            buttonLabel="PREVIOUS"
            stepLabel={prevStep.label}
            onClick={() => onChange(prevStep.value)}
          />
        )}
      </div>
      <div className="text-right">
        {nextStep && (
          <Button
            disabled={disabled}
            buttonLabel="NEXT"
            stepLabel={nextStep.label}
            onClick={() => onChange(nextStep.value)}
          />
        )}
      </div>
    </div>
  );
};

const Button = ({
  buttonLabel,
  stepLabel,
  disabled,
  onClick,
}: {
  disabled?: boolean;
  buttonLabel: string;
  stepLabel: string;
  onClick: () => void;
}) => {
  return (
    <>
      <button
        disabled={disabled}
        className={clsx(
          "font-semibold text-v2-cosmic/400 hover:text-v2-cosmic/600",
          {
            "pointer-events-none text-v2-gray/200": disabled,
          },
        )}
        onClick={onClick}
      >
        {buttonLabel}
      </button>
      <div className="text-v2-interstellar/300">{stepLabel}</div>
    </>
  );
};
